<script>
    import {onDestroy, onMount} from 'svelte';
	import { Section } from "../lib/ui";

	let primaryOptionFlag = false;
	let secondaryAutoOptionFlag = false;
	let tertiarySampleOptionFlag = false;
	let isSelectedSampleCategoryFlag = false;
	export let chat;

	const changePrimaryOption = (id) => {
		const result = chat.changePrimaryOption(id);
		if (result) {
			isSelectedSampleCategoryFlag = false;
		}
		primaryOptionFlag = false;
	}

	const changeSecondaryOption = (secondaryOption) => {
		chat.changeSecondaryOption(secondaryOption);
		secondaryAutoOptionFlag = false;
	}

	const changeTertiaryOption = (tertiaryOption) => {
		chat.changeSecondaryOption(tertiaryOption);
		tertiarySampleOptionFlag = false;
	}

	const isSelectedSampleCategory = (secondaryOption) => {
		const flag = chat.isSelectedSecondarySampleOption(secondaryOption.id);
		if (flag) {
			isSelectedSampleCategoryFlag = flag;
		}
		return flag;
	}

	const clickPrimaryOption = () => {
		isSelectedSampleCategoryFlag = false;
	}

	const clickSecondarySampleCategory = (secondaryOption) => {
		const result = chat.changeSecondaryOption(secondaryOption);
		tertiarySampleOptionFlag = false;
		if (result) {
			isSelectedSampleCategoryFlag = !isSelectedSampleCategoryFlag;
		}
	}

</script>
<div class="tw-space-y-4 tw-font-sans">
	<Section title="프롬프트 작성을 위한 옵션을 선택해주세요!">
		<div class="image-dropdown">
			<div data-delay="0" data-hover="true" class="dropdown-2 w-dropdown" style="">
				<div class="dropdown-toggle-charecter w-dropdown-toggle" id="w-dropdown-toggle-1"
					aria-controls="w-dropdown-list-1" aria-haspopup="menu" aria-expanded="false" role="button" tabindex="0"
					on:click={()=> primaryOptionFlag = !primaryOptionFlag}>
					<div class="icon-2 w-icon-dropdown-toggle" aria-hidden="true"></div>
					<div class="text-block-26">{chat.getPrimaryOptionName()}</div>
				</div>
				<nav class="dropdown-list-2 w-dropdown-list" class:w--open={primaryOptionFlag} id="w-dropdown-list-1"
					aria-labelledby="w-dropdown-toggle-1" on:mouseleave={()=>primaryOptionFlag = false}>
					{#each chat.getPrimaryOptionList() as primaryOption}
					<a href="#" class="dropdown-link w-dropdown-link pointer" tabindex="0"
						on:click={()=>changePrimaryOption(primaryOption.id)}>{primaryOption.name}</a>
					{/each}
				</nav>
			</div>
		</div>
	</Section>

	{#if chat.isAutoGenerateOption()}
	<Section title="자동 생성 템플릿의 유형을 선택해주세요!">
		<div class="div-block-4">
			<div class="tooltiptext tooltip-top">자동생성 템플릿을 선택하고 [자동생성] 버튼을 누르면 프롬프트가 자동으로 작성돼요!</div>
		</div>
		<div data-delay="0" data-hover="true" class="dropdown-2 w-dropdown" style="">
			<div class="dropdown-toggle-charecter w-dropdown-toggle" id="w-dropdown-toggle-1"
				aria-controls="w-dropdown-list-1" aria-haspopup="menu" aria-expanded="false" role="button" tabindex="0"
				on:click={()=> secondaryAutoOptionFlag = !secondaryAutoOptionFlag}>
				<div class="icon-2 w-icon-dropdown-toggle" aria-hidden="true"></div>
				<div class="text-block-26">{chat.getSecondaryOptionName()}</div>
			</div>
			<nav class="dropdown-list-2 w-dropdown-list" class:w--open={secondaryAutoOptionFlag} id="w-dropdown-list-1"
				aria-labelledby="w-dropdown-toggle-1" on:mouseleave={()=>secondaryAutoOptionFlag = false}>
				{#each chat.getSecondaryOptionList() as secondaryOption}
				<div class="sub-text-wrapper pointer" on:click={()=>changeSecondaryOption(secondaryOption)}>
					<div class="sub-text">{secondaryOption.name}</div>
					<div class="sub-description">{secondaryOption.description}</div>
				</div>
				{/each}
			</nav>
		</div>
	</Section>
	{/if}

	{#if chat.isSampleOption()}
	<Section title="프롬프트 샘플을 선택해 주세요!">
		<div class="div-block-4">
			<div class="tooltiptext tooltip-top">프롬프트 샘플을 선택할 수 있어요. 샘플은 나의 캐릭터에 맞춰 수정할 수 있어요!</div>
		</div>
		<div class="key-word">
				{#each chat.getSecondarySampleCategoryList() as secondaryOption}
				<div class="keyword" class:keyword-selected={isSelectedSampleCategory(secondaryOption)} on:click={() =>clickSecondarySampleCategory(secondaryOption)}>
				{secondaryOption.name}
				</div>
				{/each}
		</div>
		<div data-delay="0" data-hover="true" class="dropdown-2 w-dropdown" style="">
			{#if isSelectedSampleCategoryFlag}
			<div class="dropdown-toggle-charecter w-dropdown-toggle" id="w-dropdown-toggle-1"
				aria-controls="w-dropdown-list-1" aria-haspopup="menu" aria-expanded="false" role="button" tabindex="0"
				on:click={()=> tertiarySampleOptionFlag = !tertiarySampleOptionFlag}>
				<div class="icon-2 w-icon-dropdown-toggle" aria-hidden="true"></div>
				<div class="text-block-26">{chat.getTertiarySampleOptionName()}</div>
			</div>
			<nav class="dropdown-list-2 w-dropdown-list" class:w--open={tertiarySampleOptionFlag} id="w-dropdown-list-1"
				aria-labelledby="w-dropdown-toggle-1" on:mouseleave={()=>tertiarySampleOptionFlag = false}>
				{#if chat.secondaryOptionId}
					{#each chat.getTertiaryOptionList() as tertiaryOption}
					<a href="#" class="dropdown-link w-dropdown-link pointer" tabindex="0"
						on:click={()=>changeTertiaryOption(tertiaryOption)}>{tertiaryOption.name}</a>
					{/each}
				{:else}
					{#each chat.getTotalTertiaryOptionList() as tertiaryOption}
					<a href="#" class="dropdown-link w-dropdown-link pointer" tabindex="0"
						on:click={()=>changeTertiaryOption(tertiaryOption)}>{tertiaryOption.name}</a>
					{/each}
				{/if}
			</nav>
			{/if}
		</div>
	</Section>
	{/if}
</div>
<style>

	.image-dropdown {
		height: 46px;
	}

	.dropdown-toggle-charecter {
		width: 100%;
		height: 46px;
		max-width: 400px;
		display: flex;
		z-index: auto;
	}

	.dropdown-list-2 {
		width: 100%;
		max-width: 400px;
		height: auto;
		padding-bottom: 0px;
		box-shadow: 1px 1px 3px 2px rgba(85, 99, 126, 0.12);
	}

	.dropdown-2 {
		width: 100%;
		height: 46px;
		max-width: 400px;
	}

	.dropdown-link {
		width: 100%;
		max-width: 400px;
		height: 42px;
		display: flex;
  		align-items: center;
		color: hsl(var(--sb-foreground));
	}

	.dropdown-2:hover {
		outline-width: 1px;
	}

	.text-block-26 {
		font-size: 15px;
		margin-top: auto;
		margin-bottom: auto;
		margin-left: 10px;
	}

	.sub-text-wrapper {
		flex-direction: column;
    	padding: 19px;
		border-bottom: 1px solid hsl(var(--sb-border));
	}
	.sub-text-wrapper:hover {
		background-color: hsl(var(--sb-muted) / 0.4);
	}

	.sub-text {
		margin-bottom: 4px;
		font-size: 13px;
		color: hsl(var(--sb-muted-foreground));
		display: flex;
		align-items: center;
		margin-right: 10px;
		font-weight: bold;
	}
	.sub-description {
		font-size: 12px;
    	color: hsl(var(--sb-muted-foreground));
	}
	.w-dropdown {
		z-index: auto;
	}

	.keyword-selected {
		background-color: hsl(var(--sb-primary));
		color: white;
	}

	.div-block-4 {
		margin-bottom: 8px;
	}
	.div-block-4 .tooltiptext {
		width: 204px;
    	left: -33px;
	}
</style>
